import Questionnaire from './index';

export default [
    // 问卷调查
    {
        path: '/front/activities/questionnaire',
        component: Questionnaire,
        title: '问卷调查'
    }
]